import { MenuItemTitleKey } from './menu-item-title-keys.constants';

/**
 * Estado del desplegable manual del sidebar (`showMenu` / `showSubMenu`).
 *
 * - {@link Unset}: inicial, antes de aplicar expansión por ruta o por defecto.
 * - {@link Collapsed}: ninguna sección abierta por interacción del usuario (`'0'` legacy).
 * - Cualquier {@link MenuItemTitleKey}: sección desplegada manualmente (valor = `RouteInfo.title`).
 */
export enum SidebarManualExpandState {
  Unset = '',
  Collapsed = '0',
}

export type SidebarManualExpandKey = SidebarManualExpandState | MenuItemTitleKey | string;

export function isSidebarManuallyCollapsed(state: SidebarManualExpandKey): boolean {
  return !state || state === SidebarManualExpandState.Collapsed;
}
